module.exports = __webpack_public_path__ + "static/media/benefitImage2@2x.926a15da.png";